// Service id as set in the SAP account data (field: ServiceId)
export enum ServiceExternalIdentifier {
  Equivolt = "equiVolt",
  Wcc = "westfalenCompactCard",
  Wsc = "westfalenServiceCard",
  ThgQuote = "thg",
  Fbs = "fbs",
  GasShop = "gasesShop",
  GlobalGasShop = "globalgasesshop",
  Virta = "virta",
  Gaas = "gaas",
  WestfalenId = "westfalenId", // applies to all digital customers
  B2BApp = "b2bApp",
}

export const mapToServiceExternalIdentifierEnum = (
  key: string,
): ServiceExternalIdentifier => {
  if (
    Object.values(ServiceExternalIdentifier).includes(
      key as ServiceExternalIdentifier,
    )
  )
    return key as ServiceExternalIdentifier;

  throw new Error(`Unknown ServiceExternalIdentifier: ${key}`);
};
